"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RitualHistoryStatus = void 0;
var RitualHistoryStatus;
(function (RitualHistoryStatus) {
    RitualHistoryStatus["Success"] = "success";
    RitualHistoryStatus["Fail"] = "fail";
})(RitualHistoryStatus = exports.RitualHistoryStatus || (exports.RitualHistoryStatus = {}));
